export default {
  downloadPlural: 'Вивантажити вихідні файли',
  uploadPlural: 'Завантажити вихідні файли'
};
